(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mw-mixed-packs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('submit',async function(event){
  const form=event.target.closest('[data-mw-pack-form]');if(!form)return;event.preventDefault();
  const button=form.querySelector('button');if(button.disabled)return;
  const label=button.querySelector('span');const original=label.textContent;const message=form.querySelector('[role="status"]');button.disabled=true;label.textContent='Adding…';message.textContent='';
  const fields=new FormData(form);const items=[];
  for(const [name,value] of fields){if(/^items\[\d+\]\[id\]$/.test(name))items.push({id:Number(value),quantity:1});}
  try{const response=await fetch(form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||'We couldn’t add this pack. Please check the individual bottles.');window.location.assign(form.action.replace(/\/add$/,'') );}
  catch(error){message.textContent=error.message||'We couldn’t add this pack. Please try again.';label.textContent=original;button.disabled=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-wine-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const copy = JSON.parse(root.querySelector('[data-quiz-copy]').textContent);
    const view = root.querySelector('[data-quiz-content]');
    const base = root.querySelector('[data-quiz-root]').textContent.trim().replace(/\/?$/, '/');
    const currency = root.querySelector('[data-quiz-currency]').textContent.trim();
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(value);
    const esc = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    const questions = [
      {key:'type',title:copy.type_prompt,hint:copy.type_hint,options:[['red',copy.red],['white',copy.white],['rose',copy.rose],['sparkling',copy.sparkling],['dessert',copy.dessert],['any',copy.any_type_label]]},
      {key:'budget',title:copy.budget_prompt,hint:copy.budget_hint,options:[['40',`${money(40)} ${copy.under}`],['60',`${money(60)} ${copy.under}`],['any',copy.any_budget]]},
      {key:'brand',title:copy.brand_prompt,hint:copy.brand_hint,options:[['any',copy.all_labels],['muni',copy.muni],['potek',copy.potek],['nowadays',copy.nowadays]]}
    ];
    let step = -1, answers = {}, products = null, error = false, pending = null;
    const classify = p => {
      const tags = p.tags.map(t => t.toLowerCase().trim());
      if (tags.includes('sparkling wine')) return 'sparkling';
      if (tags.includes('dessert-wine') || tags.includes('dessert wine')) return 'dessert';
      if (tags.includes('rose') || tags.includes('rosé')) return 'rose';
      if (tags.includes('red wine')) return 'red';
      if (tags.includes('white wine')) return 'white';
      return null;
    };
    const brandOf = p => ({'Muni Wine':'muni','Potek Winery':'potek','Nowadays':'nowadays','Nowadays Wine':'nowadays'}[p.vendor]);
    const eligible = p => p.product_type === 'Wine Bottle' && !!brandOf(p) && !p.requires_selling_plan && p.variants.some(v => v.available);
    const priceOf = p => Math.min(...p.variants.filter(v => v.available).map(v => Number(v.price)));
    const matches = p => eligible(p) && (answers.type === 'any' || classify(p) === answers.type) && (answers.budget === 'any' || priceOf(p) <= Number(answers.budget)) && (answers.brand === 'any' || brandOf(p) === answers.brand);
    const heading = text => `<h1 class="wq-title wq-heading-focus" tabindex="-1">${esc(text)}</h1>`;
    const button = (action,label,primary=false) => `<button type="button" class="${primary?'wq-primary':'wq-text-button'}" data-action="${action}">${esc(label)}</button>`;
    const shop = `<a class="wq-text-button" href="${base}collections/current-available-wines">${esc(copy.shop)}</a>`;
    function focusHeading() { view.querySelector('h1')?.focus({preventScroll:true}); }
    async function load() {
      if (pending) return pending;
      if (products) return;
      error = false;
      pending = (async () => {
        const catalog = [];
        try {
          for (let page=1;page<=10;page++) {
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 12000);
            let payload;
            try {
              const response = await fetch(`${base}collections/current-available-wines/products.json?limit=250&page=${page}`, {signal:controller.signal,headers:{Accept:'application/json'}});
              if (!response.ok) throw new Error('Catalog unavailable');
              payload = await response.json();
              if (!Array.isArray(payload.products)) throw new Error('Catalog invalid');
            } finally {clearTimeout(timer);}
            catalog.push(...payload.products);
            if (payload.products.length < 250) break;
          }
          products = catalog.filter(p => p && typeof p.title === 'string' && typeof p.handle === 'string' && Array.isArray(p.tags) && Array.isArray(p.variants));
        } catch (_) {error = true;}
        finally {pending = null;if(step===3) render(true);}
      })();
      return pending;
    }
    function resultCard(p) {
      const type = classify(p), brand = brandOf(p), price = priceOf(p);
      const prices = p.variants.filter(v=>v.available).map(v=>Number(v.price));
      const image = p.images?.[0]?.src;
      const safeImage = image && /^https:\/\//.test(image);
      return `<a class="wq-product" data-brand="${brand}" href="${base}products/${encodeURIComponent(p.handle)}"><div class="wq-product-image">${safeImage?`<img src="${esc(image)}" alt="${esc(p.title)}" width="160" height="220" loading="lazy">`:''}</div><div class="wq-product-copy"><p>${esc(copy[brand])}${type?` · ${esc(copy[type])}`:''}</p><h2>${esc(p.title)}</h2><p>${Math.max(...prices)>price?`${esc(copy.from)} `:''}${esc(money(price))}</p><span class="wq-product-link">${esc(copy.view)} →</span></div></a>`;
    }
    function render(focus=false) {
      if (step === -1) {
        view.innerHTML = `<p class="wq-kicker">${esc(copy.kicker)}</p>${heading(copy.title)}<p class="wq-description">${esc(copy.intro)}</p>${button('start',copy.start,true)}<p class="wq-fine">${esc(copy.promise)}</p>`;
      } else if (step < 3) {
        const q = questions[step];
        view.innerHTML = `<p class="wq-kicker">${esc(copy.step)} ${step+1} ${esc(copy.of)} 3</p>${heading(q.title)}<p class="wq-description">${esc(q.hint)}</p><div class="wq-progress" aria-hidden="true">${questions.map((_,i)=>`<span class="${i<=step?'is-complete':''}"></span>`).join('')}</div><fieldset class="wq-options" aria-label="${esc(q.title)}">${q.options.map(([value,label])=>`<label class="wq-option"><input type="radio" name="wine-quiz-${q.key}" value="${value}" ${answers[q.key]===value?'checked':''}><span>${esc(label)}</span></label>`).join('')}</fieldset><div class="wq-actions">${button('back',copy.back)}<button type="button" class="wq-primary" data-action="next" ${answers[q.key]?'':'disabled'}>${esc(step===2?copy.results:copy.next)} →</button></div>`;
      } else if (error) {
        view.innerHTML = heading(copy.error)+`<div class="wq-actions">${button('retry',copy.retry,true)}${shop}${button('edit',copy.edit)}</div>`;
      } else if (!products) {
        view.innerHTML = heading(copy.loading)+`<p role="status">${esc(copy.loading)}</p>${button('edit',copy.edit)}`;
      } else {
        const found = products.filter(matches);
        const chosen = [];
        if (answers.brand==='any') {
          ['muni','potek','nowadays'].forEach(brand=>{const match=found.find(p=>brandOf(p)===brand);if(match)chosen.push(match);});
        }
        found.forEach(p=>{if(chosen.length<3 && !chosen.includes(p))chosen.push(p);});
        const summary = [answers.type==='any'?copy.any_type:copy[answers.type],answers.budget==='any'?copy.any_budget:`${money(Number(answers.budget))} ${copy.under}`,answers.brand==='any'?copy.any_label:copy[answers.brand]].map(esc).join(' · ');
        view.innerHTML = `<p class="wq-kicker">${esc(copy.kicker)}</p>${heading(found.length?copy.result_title:copy.empty_title)}<p class="wq-description">${esc(found.length?copy.result_body:copy.empty_body)}</p><p class="wq-summary"><strong>${esc(copy.match)}:</strong> ${summary}</p>${found.length?`<div class="wq-products">${chosen.map(resultCard).join('')}</div>`:''}<div class="wq-actions">${button('edit',copy.edit,true)}${shop}${button('reset',copy.reset)}</div>`;
      }
      if (focus) focusHeading();
    }
    root.addEventListener('change',event=>{if(step<0||step>2||!event.target.matches('input[type=radio]'))return;answers[questions[step].key]=event.target.value;view.querySelector('[data-action=next]').disabled=false;});
    root.addEventListener('click',event=>{
      const action = event.target.closest('[data-action]')?.dataset.action;
      if (!action) return;
      if (action==='start') {step=0;load();}
      if (action==='next' && step<3 && answers[questions[step].key]) step++;
      if (action==='back') step=Math.max(-1,step-1);
      if (action==='edit') step=0;
      if (action==='reset') {step=-1;answers={};}
      if (action==='retry') {error=false;load();}
      render(true);
    });
    render();
  }
  document.querySelectorAll('[data-wine-quiz]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-wine-quiz]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
